import { render, staticRenderFns } from "./BlogCfg.vue?vue&type=template&id=e0f91528&"
import script from "./BlogCfg.vue?vue&type=script&lang=js&"
export * from "./BlogCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports